/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Validation_ErrorInputs */

const en_toast_validation_error = /** @type {(inputs: Toast_Validation_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validation error`)
};

const nl_toast_validation_error = /** @type {(inputs: Toast_Validation_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validatiefout`)
};

/**
* | output |
* | --- |
* | "Validation error" |
*
* @param {Toast_Validation_ErrorInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_validation_error = /** @type {((inputs?: Toast_Validation_ErrorInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Validation_ErrorInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_validation_error(inputs)
	return en_toast_validation_error(inputs)
});